module.exports = __webpack_public_path__ + "img/zone100300.7ef38f68.png";